import { AxiosRequestConfig, AxiosResponse } from "axios";
import axiosAPIInstance from "services/api";
import i18n from "i18next";

export const apiClient = {
  callApi: async <T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    try {
      const response: AxiosResponse<T> = await axiosAPIInstance(config);
      return response;
    } catch (error: any) {
      let errorMessage = i18n.t("Check_The_Logs_Error_Text");

      if (!error.response) {
        errorMessage = i18n.t("Error_Network_Error");
      } else {
        const status = error.response.status;
        const serverMessage = error.response.data?.message;

        if (status >= 500) {
          errorMessage = i18n.t("Error_Server_Error");
        } else if (status === 404) {
          errorMessage = i18n.t("Error_Resource_Not_Found");
        } else if (status === 401) {
          errorMessage = i18n.t("Error_Unauthorized_Request");
        } else if (status === 400) {
          errorMessage = serverMessage || i18n.t("Error_Bad_Request");
        } else {
          errorMessage = serverMessage || errorMessage;
        }
      }

      console.error("API Error:", {
        method: config.method,
        url: config.url,
        message: errorMessage,
      });

      throw new Error(errorMessage);
    }
  },
};
